import { useState, useEffect } from "react";

const NAV_ITEMS = [
  { label: "Inicio", href: "#hero" },
  { label: "Convivencia", href: "#convivencia-escolar" },
  { label: "Equipos", href: "#equipos-psicosociales" },
  { label: "Casos", href: "#gestion-casos" },
  { label: "IA", href: "#ia-institucional" },
];

export default function PublicNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-white/90 backdrop-blur-xl border-b border-background-200/60 shadow-soft"
            : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
          <a href="#hero" className="flex items-center gap-2.5 cursor-pointer group">
            <img src="/logos/logo.png" alt="Ezer Convivencia360" className="w-9 h-9 object-contain drop-shadow-sm group-hover:scale-105 transition-transform duration-200" />
            <span className={`text-lg font-bold tracking-tight transition-colors duration-300 ${scrolled ? "text-foreground-950" : "text-foreground-950"}`}>
              Ezer <span className="text-primary-600">Convivencia360</span>
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3.5 py-2 text-sm font-medium text-foreground-600 hover:text-foreground-900 rounded-lg hover:bg-background-100/80 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2">
            <a
              href="/login"
              className="px-5 py-2.5 bg-gradient-to-r from-primary-600 to-primary-500 text-white text-sm font-semibold rounded-xl hover:from-primary-700 hover:to-primary-600 active:scale-[0.98] transition-all duration-200 shadow-glow-primary cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-login-box-line" />
              Iniciar sesión
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-xl bg-background-100/80 text-foreground-700 cursor-pointer"
            aria-label="Menú"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={() => setMobileOpen(false)} />
          <div className="absolute top-16 left-0 right-0 bg-white/95 backdrop-blur-xl border-b border-background-200/60 shadow-soft-lg animate-slide-down">
            <div className="p-4 flex flex-col gap-1">
              {NAV_ITEMS.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMobileOpen(false)}
                  className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-50 rounded-xl transition-all duration-200 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
              <div className="mt-2 pt-2 border-t border-background-200/60">
                <a
                  href="/login"
                  className="flex items-center justify-center gap-2 px-5 py-3 bg-gradient-to-r from-primary-600 to-primary-500 text-white text-sm font-semibold rounded-xl active:scale-[0.98] transition-all duration-200 shadow-glow-primary cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-login-box-line" />
                  Iniciar sesión
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}